import React from 'react';
import { PdfTemplate } from '../types/pdf_template';

export interface PdfTemplateContextProps {
  pdfTemplates: Map<string, PdfTemplate>;
  setPdfTemplates: (pdfTemplate: Map<string, PdfTemplate>) => void;
  pdfTemplatesLoading: boolean;
}

const defaultContext: PdfTemplateContextProps = {
  pdfTemplates: new Map(),
  setPdfTemplates: () => {},
  pdfTemplatesLoading: false,
};

export const PdfTemplateContext = React.createContext<PdfTemplateContextProps>(defaultContext);
